import React from 'react'
import {
    FormControl,
    FormLabel,
} from "@chakra-ui/react";
import { CheckList } from '../CheckList';

export const FormChecklist = ({
    id,
    name,
    checkList,
    selectedList,
    checklistCallback,
    padding,
    itemPerRow,
    isRequired
}) => {
    return (
        <FormControl padding={padding} id={id} isRequired={isRequired}>
            <FormLabel
                fontSize="15px"
                textTransform="capitalize"
                fontWeight={600}
            >
                {name}
            </FormLabel>
            <CheckList
                itemPerRow={itemPerRow}
                checkList={checkList}
                selectedList={selectedList}
                parentCallback={(list) =>
                    checklistCallback(list)
                }
            />
        </FormControl>
    )
}